"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var omi_1 = require("omi");
var css = require("./index.scss");
//@ts-ignore
require("../theme.ts");
var Rate = /** @class */ (function (_super) {
    __extends(Rate, _super);
    function Rate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._current = 0;
        _this._rect = null;
        _this._hover = false;
        _this.onSelect = function (evt) {
            _this._rect = _this.base.getBoundingClientRect();
            var dx = evt.pageX - _this._rect.left;
            var value = dx / _this._rect.width * _this.props.total;
            var intValue = Math.floor(value);
            var v = intValue + (value - intValue > 0.5 ? 1 : 0.5);
            if (!_this.props.half)
                v = Math.ceil(v);
            _this.props.value = v;
            //@ts-ignore
            _this.fire('selected', v);
            _this.update();
        };
        _this.onMouseMove = function (evt) {
            _this._rect = _this.base.getBoundingClientRect();
            var dx = evt.pageX - _this._rect.left;
            _this._current = dx / _this._rect.width * _this.props.total;
            _this.update();
        };
        _this.onMouseEnter = function () {
            _this._hover = true;
        };
        _this.onMouseLeave = function () {
            _this._hover = false;
            _this.update();
        };
        _this._getClass = function (i, current) {
            if (i < current) {
                if (_this.props.half && current - i <= 0.5) {
                    return '_star _star-half ';
                }
                return '_star';
            }
            else {
                return '_star _star-empty ';
            }
        };
        return _this;
    }
    Rate.prototype.installed = function () {
        this.base = this.shadowRoot.querySelector('ul');
        //update 不再从 attr 取 prop
        this.normalizedNodeName = 'm-rate';
    };
    Rate.prototype.render = function (props) {
        var _this = this;
        return (omi_1.h("ul", __assign({ onMouseMove: this.onMouseMove, onMouseEnter: this.onMouseEnter, onMouseLeave: this.onMouseLeave, onClick: this.onSelect }, omi_1.extractClass(props, "m-rate")), Array.apply(0, Array(props.total)).map(function (x, i) {
            return omi_1.h("li", { class: _this._getClass(i, _this._hover ? _this._current : props.value) },
                omi_1.h("div", { class: 'star-box' },
                    omi_1.h("div", { class: "_star-first" },
                        omi_1.h("i", { class: "anticon anticon-star" },
                            omi_1.h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "2em", height: "2em", fill: props.color || "#f57c00", viewBox: "0 0 18 18" },
                                omi_1.h("path", { d: "M9 11.3l3.71 2.7-1.42-4.36L15 7h-4.55L9 2.5 7.55 7H3l3.71 2.64L5.29 14z" }),
                                omi_1.h("path", { fill: "none", d: "M0 0h18v18H0z" })))),
                    omi_1.h("div", { class: "_star-second" },
                        omi_1.h("i", { class: "anticon anticon-star" },
                            omi_1.h("svg", { xmlns: "http://www.w3.org/2000/svg", width: "2em", height: "2em", fill: "#E8E8E8", viewBox: "0 0 18 18" },
                                omi_1.h("path", { d: "M9 11.3l3.71 2.7-1.42-4.36L15 7h-4.55L9 2.5 7.55 7H3l3.71 2.64L5.29 14z" }),
                                omi_1.h("path", { fill: "none", d: "M0 0h18v18H0z" }))))));
        })));
    };
    Rate.css = css;
    Rate.defaultProps = {
        value: 0
    };
    Rate.propTypes = {
        value: Number,
        half: Boolean,
        total: Number,
        color: String
    };
    Rate = __decorate([
        omi_1.tag('m-rate')
    ], Rate);
    return Rate;
}(omi_1.WeElement));
exports.default = Rate;
